import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { IReceipt } from '../../../common/interfaces/dtos/IReceipt';
import { IBRMInput } from 'src/common/api/brm/brm-utils';

export const transactionCancel = async (
  transactionId: string,
  isAutoVoid: boolean = false,
  brmInputs?: IBRMInput[],
): Promise<IReceipt[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/void`,
    data: {
      isAutoVoid,
      brmInputs: brmInputs,
    },
    method: 'POST',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<IReceipt[]>(emeraldRequestParams);
};
